var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.647 12a1.1 1.1 0 0 1-.813-.337 1.122 1.122 0 0 1-.334-.82c0-.323.111-.596.334-.82a1.1 1.1 0 0 1 .813-.338h2.188l2.435-7.37H4.156a1.1 1.1 0 0 1-.813-.337 1.122 1.122 0 0 1-.334-.82c0-.322.111-.596.334-.82A1.1 1.1 0 0 1 4.156 0h6.197c.32 0 .59.112.813.337.223.225.334.499.334.82 0 .323-.111.596-.334.82a1.1 1.1 0 0 1-.813.338H8.578l-2.435 7.37h1.701c.32 0 .59.112.813.337.223.225.334.498.334.82 0 .322-.111.596-.334.82a1.101 1.101 0 0 1-.813.338H1.647z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.0fb85b3425727f019023cec852f2e131.svg";
export { ForwardRef as ReactComponent };